module.exports = __webpack_public_path__ + "img/logo-alt.224036af.svg";